<template>
  <section class="crm-insight-strip" :aria-label="title">
    <div class="crm-insight-strip__intro">
      <span class="crm-insight-strip__eyebrow">{{ eyebrow }}</span>
      <strong>{{ title }}</strong>
      <small>{{ description }}</small>
    </div>

    <div class="crm-insight-strip__metrics">
      <article
        v-for="metric in metrics"
        :key="metric.label"
        class="crm-insight-metric"
        :class="`crm-insight-metric--${metric.tone || 'neutral'}`"
      >
        <span class="crm-insight-metric__icon" aria-hidden="true">
          <i :class="metric.icon || 'fas fa-chart-line'"></i>
        </span>
        <span class="crm-insight-metric__content">
          <strong>{{ metric.value }}</strong>
          <small>{{ metric.label }}</small>
        </span>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "CrmInsightStrip",
  props: {
    eyebrow: {
      type: String,
      default: "Ringkasan CRM",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    metrics: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
